<section class="about-community-section" *ngIf="section">
  <div class="about-community-inner">
    <div class="about-community-copy">
      <p class="about-community-eyebrow">{{ section.sectionEyebrow }}</p>
      <h2>
        {{ section.title }}
        <span>{{ section.accentWord }}</span>
      </h2>
      <p class="about-community-paragraph" *ngFor="let paragraph of section.paragraphs">{{ paragraph }}</p>
    </div>
    <div class="about-community-metrics">
      <app-about-community-metric-card
        *ngFor="let metric of section.metrics"
        [metric]="metric"
      ></app-about-community-metric-card>
    </div>
  </div>
</section>
